<template>
  <BreadCrumb :PageTitle="t('breadCrumb.moneyTransfers')" />
  <TransfertsContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransfertsContent from "../../components/CRM/Leads/TransfertsContent.vue";


export default defineComponent({
  name: "TransfertsPage",
  components: {
    BreadCrumb,
    TransfertsContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>